export default __webpack_public_path__ + "static/media/Multi-party.0e404bca.svg";